import React from 'react';

import PropTypes from 'prop-types';
import { TagContainer } from './css';

const Tag = ({tagLabel }) => {
  return (
    <TagContainer>
      {tagLabel}
    </TagContainer>
  );
};

Tag.propTypes = {
  tagLabel: PropTypes.string.isRequired
};

export default Tag;
